export const BASE_URL = process.env.BASE_URL;

export const ROOT_BASE_URL = BASE_URL.replace('/so', '');

export const ROOT = '/root';
export const ADMIN = '/admin';
export const LOGIN = '/token/login';
export const LOGIN_MFA = '/mfa';
export const CONTEXT = '/token/context';
export const GATES_CONTEXT = '/gates/token/context';
export const GATES_MFA = '/gates/mfa';
export const TRANSLATIONS = '/translations';
export const SELF_SERVICE = '/selfServices';
export const GET_MEDIA = '/medias';
export const GET_MEDIA_UPLOAD_URL = '/medias/url';
export const KIOSK = '/kiosks';
export const PING = '/token/ping';
export const VEHICLE_CHECK = '/vehicleCheck';
export const VEHICLE_CHECK_MODEL = '/vehicleCheckModel';
export const QR_CODE_LOGIN_PATH = '/code/login';
export const QR_CODE = '/qrcode';
export const SLOT = '/slots';
export const REFDATA = '/refdata';
export const CONFIRMATION_BASE_URL = '/confirmation';

// SEE: `src/modules/medias/service.ts` line 18 (`uploadMedia: build.mutation // ...`)
export const TOKEN_EXCLUDED_ENDPOINTS = [
  'getContext',
  'loginAdmin',
  'uploadMedia',
  'getLanguages',
  'getVCContext',
  'getGatesContext',
  'checkQRCodeToken',
  'getTranslationsByLanguage',
  'sendMetrics',
  'getVersion',
  'getQRCode',
  'getRefData',
];

export const LOGIN_TOKEN_ENDPOINTS = ['login', 'getMFAConnection', 'sendMFACode', 'loginMFA', 'sendQrCode'];
export const ADMIN_TOKEN_ENDPOINTS = [
  'getKioskData',
  'openSlotAsAdmin',
  'closeSlotAsAdmin',
  'updateSlotAsAdmin',
  'openDoorsEmergency',
  'unprepareSlotAsAdmin',
  'getReadySelfServices',
];

export const GATES_TOKEN_ENDPOINTS = ['beginGateMFA', 'sendGateMFA', 'loginGateMFA'];

export const GATES_ACCESS_ENDPOINTS = ['getGate', 'openGate'];

export const excludedPathsToFetchContext = ['/vehicle-check/*', '/gates/*', '/payment-success/*', '/payment-failure/*', '/error/*', `${CONFIRMATION_BASE_URL}/*`, '/redirect/*'];

// eslint-disable-next-line no-useless-escape,max-len
export const URL_REGEX = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/im;
